import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const TermsOfService = ({ isOpen, onClose }) => {
  const { isDark } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className={`relative w-full max-w-4xl max-h-[70vh] overflow-y-auto rounded-2xl shadow-2xl ${
        isDark ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'
      }`}>
        {/* Header */}
        <div className={`flex items-center justify-between p-6 border-b ${
          isDark ? 'border-gray-700' : 'border-gray-200'
        }`}>
          <h2 className="text-2xl font-bold">Terms of Service</h2>
          <button
            onClick={onClose}
            className={`p-2 rounded-lg transition-colors duration-200 ${
              isDark 
                ? 'hover:bg-gray-700 text-gray-400 hover:text-white' 
                : 'hover:bg-gray-100 text-gray-500 hover:text-gray-700'
            }`}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <div className="text-sm text-gray-500 dark:text-gray-400">
            Last updated: {new Date().toLocaleDateString()}
          </div>

          <section>
            <h3 className="text-lg font-semibold mb-2">1. Acceptance of Terms</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              By accessing and using Codepact's services, you accept and agree to be bound by the 
              terms and provision of this agreement. If you do not agree to abide by the above, 
              please do not use this service.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">2. Use License</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-2">
              Permission is granted to temporarily download one copy of Codepact's materials for 
              personal, non-commercial transitory viewing only. This is the grant of a license, not a 
              transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-600 dark:text-gray-300">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">3. Service Availability</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              We strive to provide continuous service availability, but we do not guarantee that our 
              services will be uninterrupted or error-free. We reserve the right to modify, suspend, 
              or discontinue any part of our services at any time without notice.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">4. User Responsibilities</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed mb-2">
              You are responsible for:
            </p>
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-600 dark:text-gray-300">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Ensuring your use of our services complies with applicable laws</li>
              <li>Not using our services for any unlawful or prohibited purpose</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">5. Intellectual Property</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              The content, organization, graphics, design, compilation, magnetic translation, digital 
              conversion, and other matters related to the site are protected under applicable 
              copyrights, trademarks, and other proprietary rights. The copying, redistribution, 
              use, or publication by you of any such matters or any part of the site is strictly prohibited.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">6. Limitation of Liability</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              In no event shall Codepact or its suppliers be liable for any damages (including, without 
              limitation, damages for loss of data or profit, or due to business interruption) arising 
              out of the use or inability to use the materials on Codepact's website, even if Codepact 
              or a Codepact authorized representative has been notified orally or in writing of the 
              possibility of such damage.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">7. Termination</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              We may terminate or suspend your account and bar access to the service immediately, 
              without prior notice or liability, under our sole discretion, for any reason whatsoever 
              and without limitation, including but not limited to a breach of the Terms.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-2">8. Governing Law</h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              These Terms shall be interpreted and governed by the laws of the State of California, 
              without regard to its conflict of law provisions. Our failure to enforce any right or 
              provision of these Terms will not be considered a waiver of those rights.
            </p>
          </section>

        </div>

        {/* Footer */}
        <div className={`sticky bottom-0 p-6 border-t ${
          isDark ? 'border-gray-700 bg-gray-800' : 'border-gray-200 bg-white'
        }`}>
          <div className="flex justify-end">
            <button
              onClick={onClose}
              className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-colors duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
